import { xGridNumberSort } from '@AMIEWEB/Common';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { GridPreProcessEditCellProps } from '@mui/x-data-grid';
import { missingField } from 'app/constants';
import { isNumber } from 'lodash';
import { AdultNameCell } from './AdultGridComponents/AdultNameCell';
import { AdultRelationshipCell } from './AdultGridComponents/AdultRelationshipCell';
import { ChildrenAgeCell } from './ChildrenGridComponents/ChildrenAgeCell';
import { ChildrenGenderCell } from './ChildrenGridComponents/ChildrenGenderCell';
import { ErrorToolTipGender } from './Helpers/ErrorToolTipGender';
import { ErrorToolTipName } from './Helpers/ErrorToolTipName';
import { ErrorToolTipRelationship } from './Helpers/ErrorToolTipRelationship';
import { ErrorToolTipType } from './Helpers/ErrorToolTipType';
import { ErrorTootlTipAge } from './Helpers/ErrorTootlTipAge';
import { PetBreedCell } from './PetsGridComponents/PetBreedCell';
import { PetDetailsCell } from './PetsGridComponents/PetDetailsCell';
import { PetTypeCell } from './PetsGridComponents/PetTypeCell';
import { PetWeightCell } from './PetsGridComponents/PetWeightCell';
export const defaultPreferenceColumn = {
  ...XGridDefaultColumn,
  flex: 0,
};
export const getAdultsGridColumns = (t, isExpanded, isModEdit, classes, editPreferenceAdultRequests) => [
  {
    ...defaultPreferenceColumn,
    field: 'name',
    headerName: isModEdit ? `${t('placement.placementMods.name')}*` : t('placement.placementMods.name'),
    width: 274,
    hide: false,
    type: 'string',
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: AdultNameCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const rowData = getDisplayValue(params.row.id, editPreferenceAdultRequests);
      if (inValidString(rowData?.name)) {
        return { ...params.props.row, error: true, errorField: 'name' };
      } else {
        return { ...params.props.row, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (!isModEdit) return null;
      const rowData = getDisplayValue(params.row.id, editPreferenceAdultRequests);
      if (inValidString(rowData?.name)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },

    renderCell: params => {
      return isModEdit ? ErrorToolTipName(params) : params?.row?.name ? params?.row?.name : missingField;
    },
  },
  {
    ...defaultPreferenceColumn,
    field: 'relationship',
    headerName: isModEdit ? `${t('placement.placementMods.relationship')}*` : t('placement.placementMods.relationship'),
    width: isExpanded ? 852 : 274,
    hide: false,
    type: 'string',
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: AdultRelationshipCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const rowData = getDisplayValue(params.row.id, editPreferenceAdultRequests);
      if (inValidString(rowData?.relationship)) {
        return { ...params.props.row, error: true, errorField: 'relationship' };
      } else {
        return { ...params.props.row, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (!isModEdit) return null;
      const rowData = getDisplayValue(params.row.id, editPreferenceAdultRequests);
      if (inValidString(rowData?.relationship)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },

    renderCell: params => {
      return isModEdit
        ? ErrorToolTipRelationship(params)
        : params?.row?.relationship
        ? params?.row?.relationship
        : missingField;
    },
  },
];

export const getChildrenGridColumns = (t, isExpanded, isModEdit, classes, editPreferenceChildrenRequests) => [
  {
    ...defaultPreferenceColumn,
    field: 'gender',
    headerName: isModEdit ? `${t('placement.placementMods.gender')}*` : t('placement.placementMods.gender'),
    width: 274,
    hide: false,
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: ChildrenGenderCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const rowData = getDisplayValue(params.row.id, editPreferenceChildrenRequests);
      if (inValidString(rowData?.gender)) {
        return { ...params.props.row, error: true, errorField: 'gender' };
      } else {
        return { ...params.props.row, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (!isModEdit) return null;
      const rowData = getDisplayValue(params.row.id, editPreferenceChildrenRequests);
      if (inValidString(rowData?.gender)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    renderCell: params => {
      return isModEdit ? ErrorToolTipGender(params) : params?.row?.gender ? params?.row?.gender : missingField;
    },
  },
  {
    ...defaultPreferenceColumn,
    field: 'age',
    headerName: isModEdit ? `${t('placement.placementMods.age')}*` : t('placement.placementMods.age'),
    width: isExpanded ? 852 : 274,
    hide: false,
    editable: isModEdit,
    hideable: !isModEdit,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    renderEditCell: ChildrenAgeCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const rowData = getDisplayValue(params.row.id, editPreferenceChildrenRequests);
      if (!isNumber(rowData?.age)) {
        return { ...params.props.row, error: true, errorField: 'age' };
      } else {
        return { ...params.props, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (!isModEdit) return null;
      const rowData = getDisplayValue(params.row.id, editPreferenceChildrenRequests);
      if (!isNumber(rowData?.age)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    renderCell: params => {
      return isModEdit ? ErrorTootlTipAge(params) : params?.row?.age ? params?.row?.age : missingField;
    },
    sortComparator: xGridNumberSort,
  },
];

export const getPetsGridColumns = (t, isExpanded, isModEdit, classes, editPreferencePetsRequests) => [
  {
    ...defaultPreferenceColumn,
    field: 'type',
    headerName: isModEdit ? `${t('placement.placementMods.type')}*` : t('placement.placementMods.type'),
    width: 146,
    hide: false,
    type: 'string',
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: PetTypeCell,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const rowData = getDisplayValue(params.row.id, editPreferencePetsRequests);
      if (inValidString(rowData?.type)) {
        return { ...params.props.row, error: true, errorField: 'type' };
      } else {
        return { ...params.props.row, error: false, errorField: null };
      }
    },
    cellClassName: params => {
      if (!isModEdit) return null;
      const rowData = getDisplayValue(params.row.id, editPreferencePetsRequests);
      if (inValidString(rowData?.type)) {
        return classes.isErrorCell;
      } else {
        return null;
      }
    },
    renderCell: params => {
      return isModEdit ? ErrorToolTipType(params) : params?.row?.type ? params?.row?.type : missingField;
    },
  },
  {
    ...defaultPreferenceColumn,
    field: 'breed',
    headerName: t('placement.placementMods.breed'),
    width: 146,
    hide: false,
    editable: isModEdit,
    hideable: !isModEdit,
    type: 'string',
    renderEditCell: PetBreedCell,
    renderCell: params => {
      if (!isModEdit) return params?.row?.breed ? params?.row?.breed : missingField;
      const rowData = getDisplayValue(params.row.id, editPreferencePetsRequests);
      return rowData?.breed ? rowData?.breed : '--';
    },
  },
  {
    ...defaultPreferenceColumn,
    field: 'weight',
    headerName: t('placement.placementMods.weight'),
    width: 146,
    hide: false,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: PetWeightCell,
    renderCell: params => {
      if (!isModEdit) return params?.row?.weight ? params?.row?.weight : missingField;
      const rowData = getDisplayValue(params.row.id, editPreferencePetsRequests);
      return isNumber(rowData?.weight) ? rowData?.weight : '--';
    },
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultPreferenceColumn,
    field: 'details',
    headerName: t('placement.placementMods.details'),
    width: isExpanded ? 688 : 110,
    hide: false,
    type: 'string',
    editable: isModEdit,
    hideable: !isModEdit,
    renderEditCell: PetDetailsCell,
    renderCell: params => {
      if (!isModEdit) return params?.row?.details ? params?.row?.details : missingField;
      const rowData = getDisplayValue(params.row.id, editPreferencePetsRequests);
      return rowData?.details ? rowData?.details : '--';
    },
  },
];

export const inValidString = string =>
  string === missingField || string === '' || string === null || string === undefined;

export const generateRandomId = (length = 7) =>
  Math.floor(Math.random() * (9 * 10 ** (length - 1)) + 10 ** (length - 1));

export const getDisplayValue = (id, rows = []) => (rows || []).find(item => item.id === id);
